import React from "react";
import { Link } from "react-router-dom";
import * as _ from "lodash";
import { connect } from "react-redux";
import Dropdown from "react-dropdown";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as moment from "moment";
import { bindActionCreators } from "redux";
import parse, { attributesToProps } from 'html-react-parser';
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import AddVehicleInEligibility from "./addVehicleModal";
import exclamation from "../../images/exclamation-xxl.png";
import QuestionComponent from "./QuestionComponent";
import {
  saveUsersUneligibleSettlements,
  tutorialPopupStateAction2,
  tutorialPopupStateAction3,
  tutorialPopupStateAction,
  tutorialPopupStateAction4,
  tutorialPopupStateAction5,
  clearTutorialPopupStateAction,
  clearTutorialPopupStateAction2,
  clearTutorialPopupStateAction3,
  clearTutorialPopupStateAction4,
  getConsumerUser,
  clearTutorialPopupStateAction5,
} from "../../Actions/actions";

import BigMoney from "./bigMoney";
import SettlementModal from "./settlementModal";

function TabContainer(props) {
  return (
    <Typography component='div' style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class PlanStub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openInfoDialog: false,
      enrolmentdate: "",
      settlementDocumentDtoList1: [],
      recentAnswer: [],
      PopErrorNotAllowedToMove: false,
      closedQuitionair: false,
      openReviewDialog: false,
      openReviewDialogDoc: false,
      error: "",
      openComponents: false,
      openVehiclePop: false,
      tutorialPopupState1: false,
      setFilteredDSettlementState: false,
    };
    this.onViewAll = this.onViewAll.bind(this);
    this.ProceedWithQuestion = this.ProceedWithQuestion.bind(this);
    this.MultiselectOptions = this.MultiselectOptions.bind(this);
    this.radioSelectOption = this.radioSelectOption.bind(this);
    this.inputSelctorOptions = this.inputSelctorOptions.bind(this);
    this.inputSelctorOptionsNumber = this.inputSelctorOptionsNumber.bind(this);
    this.inputSelctorOptionsAdd = this.inputSelctorOptionsAdd.bind(this);
    this.inputSelctorOptionsSub = this.inputSelctorOptionsSub.bind(this);

    this._onSelect = this._onSelect.bind(this);
    this.multipleInputOptions = this.multipleInputOptions.bind(this);
    this.openModalVehicle = this.openModalVehicle.bind(this);
  }

  handleReviewClose = () => {
    this.setState({ openReviewDialog: false, openReviewDialogDoc: false });
  };
  componentWillMount() {
    this.props.getConsumerUser(localStorage.getItem('userId'));
  }

  componentDidMount() {
    console.log('this.props.data.setFilteredDSettlement', localStorage.getItem("showTutorial"), this.props.data.setFilteredDSettlement)

    setTimeout(() => {
      if(this.props.data.setFilteredDSettlement && this.props.data.setFilteredDSettlement.records){
        this.setState({
          setFilteredDSettlementState: true
        })
        if((this.props.data.setFilteredDSettlement.records.length < 1)) {
          localStorage.removeItem("showTutorial")
        }else{  
          if (localStorage.getItem("showTutorial")) {
            if((localStorage.getItem("roleName") == "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
              if(window.innerWidth < 376){
                window.scroll({
                  top: 250,
                  left: 600,
                  behavior: 'smooth'
                });
              }else{
                window.scroll({
                  top: 250,
                  left: 600,
                  behavior: 'smooth'
                });
              }
      
              this.setState({ tutorialPopupState1: true }, () => {
                // localStorage.removeItem("showTutorial");
                document.addEventListener("mousedown", this.handleClickOutside);
              });
            }else if ((localStorage.getItem("roleName") == "Consumer" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
              window.scroll({
                top: 550,
                left: 600,
                behavior: 'smooth'
              });
              if(window.innerWidth < 376){
                window.scroll({
                  top: 1200,
                  left: 600,
                  behavior: 'smooth'
                });
              }
              if(window.innerWidth > 376 && window.innerWidth < 415){
                window.scroll({
                  top: 1200,
                  left: 600,
                  behavior: 'smooth'
                });
              }
              this.setState({ tutorialPopupState1: true }, () => {
                // localStorage.removeItem("showTutorial");
                document.addEventListener("mousedown", this.handleClickOutside);
              });
            }
          }
        }
      }else if(this.props.data.setFilteredDSettlement.lenght == 0){
        localStorage.removeItem("showTutorial")
      }
    }, 1000);
  }

  handleClickOutside = () => {
    if (localStorage.getItem("showTutorial") && this.state.tutorialPopupState1 == true) {
      if((localStorage.getItem("roleName") == "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        if (this.state.tutorialPopupState1 == true && localStorage.getItem("email")) {
          this.setState({ tutorialPopupState1: false });
          this.props.tutorialPopupStateAction2({ tutorialPopupState2: true });
        }
      }else if ((localStorage.getItem("roleName") == "Consumer" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
        if(window.innerWidth < 376){
          window.scroll({
            top: 1,
            left: 1,
            behavior: 'smooth'
          });
        }else{
          window.scroll({
            top: 1,
            left: 1,
            behavior: 'smooth'
          });
        }
        if (this.state.tutorialPopupState1 == true && localStorage.getItem("email")) {
          this.setState({ tutorialPopupState1: false });
          this.props.tutorialPopupStateAction3({ tutorialPopupState3: true });
        }
      }
    }
  };

  handleClickOutside4 = () => {
    if (localStorage.getItem("showTutorial") && this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == true) {   
    if((localStorage.getItem("roleName") == "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      if (this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == true && (!this.props.data.tutorialPopupStateAction.tutorialPopupState || this.props.data.tutorialPopupStateAction.tutorialPopupState == false)) {
        if(window.innerWidth < 376){
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }else{
          window.scroll({
            top: 1,
            left: 1,
            behavior: 'smooth'
          });
        }
        localStorage.removeItem("showTutorial");
        this.props.tutorialPopupStateAction4({ tutorialPopupState4: false });
        this.props.tutorialPopupStateAction({ tutorialPopupState: true });
        this.props.clearTutorialPopupStateAction();
        this.props.clearTutorialPopupStateAction2();
        this.props.clearTutorialPopupStateAction3();
        this.props.clearTutorialPopupStateAction4();
      }
    }else if ((localStorage.getItem("roleName") == "Consumer" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      if(window.innerWidth < 376){
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }else{
        window.scroll({
          top: 1,
          left: 1,
          behavior: 'smooth'
        });
      }
      if (this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == true && localStorage.getItem("email")) {
        this.props.tutorialPopupStateAction4({ tutorialPopupState4: false });
        this.props.tutorialPopupStateAction5({ tutorialPopupState5: true });
      }
    }
  }
  };

  handleClickOutside5 = () => {
    if (localStorage.getItem("showTutorial") && this.props.data.tutorialPopupStateAction5.tutorialPopupState5 == true) {
    if((localStorage.getItem("roleName") != "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      if(this.props.data.tutorialPopupStateAction5.tutorialPopupState5 == true && (!this.props.data.tutorialPopupStateAction.tutorialPopupState || this.props.data.tutorialPopupStateAction.tutorialPopupState == false)){
        localStorage.removeItem("showTutorial");
        if(window.innerWidth < 376){
          window.scroll({
            top: 1,
            left: 1,
            behavior: 'smooth'
          });
        }else{
          window.scroll({
            top: 1,
            left: 1,
            behavior: 'smooth'
          });
        }
        this.props.tutorialPopupStateAction5({ tutorialPopupState5: false });
        this.props.tutorialPopupStateAction({ tutorialPopupState: true });
        this.props.clearTutorialPopupStateAction();
        this.props.clearTutorialPopupStateAction2();
        this.props.clearTutorialPopupStateAction3();
        this.props.clearTutorialPopupStateAction4();
        this.props.clearTutorialPopupStateAction5();
      }
    }
  }
  }
  handleClickOutside2 = () => {
    if (localStorage.getItem("showTutorial") && this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == true) {
    if((localStorage.getItem("roleName") == "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      if(window.innerWidth < 376){
        window.scroll({
          top: 1,
          left: 1,
          behavior: 'smooth'
        });
      }else{
        window.scroll({
          top: 1,
          left: 1,
          behavior: 'smooth'
        });
      }
      if (this.state.tutorialPopupState1 == false && this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == true && localStorage.getItem("email")) {
        this.props.tutorialPopupStateAction2({ tutorialPopupState2: false });
        this.props.tutorialPopupStateAction3({ tutorialPopupState3: true });
      }
    }else if ((localStorage.getItem("roleName") == "Consumer" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      if (this.state.tutorialPopupState1 == false && localStorage.getItem("email")) {
        this.setState({
          tutorialPopupState1:false
        })
        this.props.tutorialPopupStateAction3({ tutorialPopupState3: true });
      }
    }
  }
  };

  handleClickOutside3 = () => {
    if (localStorage.getItem("showTutorial") && (this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true || localStorage.getItem("roleName") == "Business-User" || localStorage.getItem("roleName") == "Consumer")) {
    if((localStorage.getItem("roleName") == "Business-User" && !this.props.data.tutorialPopupStateAction.tutorialPopupState) || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) {
      window.scroll({
        top: 150,
        left: 600,
        behavior: 'smooth'
      });
    }else if ((localStorage.getItem("roleName") == "Consumer" && (!this.props.data.tutorialPopupStateAction.tutorialPopupState || this.props.data.tutorialPopupStateAction.tutorialPopupState == false) && (!this.props.data.tutorialPopupStateAction2.tutorialPopupState2 || this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == false) && (!this.props.data.tutorialPopupStateAction5.tutorialPopupState5 || this.props.data.tutorialPopupStateAction5.tutorialPopupState5 == false))) {
      if(window.innerWidth < 376){
        window.scroll({
          top: 1200,
          left: 600,
          behavior: 'smooth'
        });
      }
    }
  }
  };

  handleReviewOpen = () => {
    this.setState({ openReviewDialog: true });
  };

  openModalVehicle() {
    this.setState({
      openComponents: true,
    });
  }

  handleReviewDoc = () => {
    this.setState({ openReviewDialogDoc: true });
  };

  showQuestion = (e) => {
    e.preventDefault();
    this.setState({
      PopErrorNotAllowedToMove: false,
    });
  };

  handleCloseModal = (langValue) => {
    this.setState({ openComponents: langValue });
  };

  MultiselectOptions(id) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    const isIn = answerArr.indexOf(id);

    if (isIn > -1) {
      answerArr.splice(isIn, 1);
    } else {
      answerArr.push(id);
    }

    this.setState({
      recentAnswer: answerArr,
      error: "",
    });
  }

  radioSelectOption(id) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    if (answerArr.length > 0) {
      answerArr = [];
    }
    answerArr.push(id);
    this.setState({
      recentAnswer: answerArr,
      error: "",
    });
  }

  inputSelctorOptionsAdd() {
    const { recentAnswer } = this.state;
    if (recentAnswer.length === 0) {
      this.setState({
        recentAnswer: 1,
      });
    } else {
      this.setState({
        recentAnswer: recentAnswer + 1,
      });
    }
  }

  inputSelctorOptionsSub() {
    const { recentAnswer } = this.state;
    if (recentAnswer.length === 0) {
      this.setState({
        recentAnswer: 0,
      });
    } else if (recentAnswer > 0) {
      this.setState({
        recentAnswer: recentAnswer - 1,
      });
    } else {
      this.setState({
        recentAnswer,
      });
    }
  }

  inputSelctorOptionsNumber(e) {
    this.setState({
      [e.target.name]: parseInt(e.target.value, 10),
      error: "",
    });
  }

  inputSelctorOptions(e) {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  }

  _onSelect(e) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    if (answerArr.length > 0) {
      answerArr = [];
    }
    answerArr.push(e.value);
    this.setState({
      recentAnswer: answerArr,
      error: "",
    });
  }

  multipleInputOptions(e) {
    const val = e.target.value;
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    answerArr.push(val);
    this.setState({
      recentAnswer: answerArr,
      error: "",
    });
  }

  onViewAll() {
    this.context.router.history.push("/settlement");
  }

  openModalVehiclePop = () => {
    this.setState({
      openVehiclePop: true,
    });
  };

  handleVehiclClosePop = () => {
    this.setState({
      openVehiclePop: false,
    });
  };

  ProceedWithQuestion() {
    const { recentAnswer } = this.state;
    const QuestionList = this.props.questionToDO;
    const userid = localStorage.getItem("userId");
    const currentQuestionTypeId = QuestionList[0].questionTypeId;
    if (currentQuestionTypeId !== 9) {
      if (recentAnswer.length === 0) {
        this.setState({
          error: "Please answer the question ",
        });
        return false;
      }
    }
    const answerObj = {};
    answerObj.id = this.props.enrId;
    let mainSubAnswerArray = [];
    mainSubAnswerArray =
      answerObj.eligibilityQuestionDtoList !== undefined &&
      answerObj.eligibilityQuestionDtoList.length > 0
        ? answerObj.eligibilityQuestionDtoList
        : [];
    const LocalAnswerObj = {};
    const ansArray = [];
    const moveToNextFlag = [];
    const isQualify = [];
    const isMatch = [];
    const theCurrentQuestion = 0;
    const Type = QuestionList[theCurrentQuestion].questionTypeId;
    const questionId = QuestionList[theCurrentQuestion].eligibilityQuestionId;
    const settlementId = QuestionList[theCurrentQuestion].settlementId;
    const answerOptions = QuestionList[theCurrentQuestion].eligibilityAnswerDto;
    // code for multiselect and type 2
    if (Type === 1 || Type === 5) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      for (let i = 0; i < recentAnswer.length; i++) {
        answerOptions.map((item) => {
          if (item.isDisabled !== 1) {
            if (item.answerId === recentAnswer[i]) {
              if (item.moveToNextQuestion === 0) {
                moveToNextFlag.push({
                  moveToNextQuestion: false,
                  answerID: item.answerId,
                });
              }

              if (item.isQualify === 0) {
                isQualify.push({ isQualify: false, answerID: item.answerId });
              }
              ansArray.push({
                eligibilityQuestionId: questionId,
                userId: userid,
                value: item.answerText,
                eligibilityAnswerId: item.answerId,
                optionalNotesData : item.optionalNotesData
              });
            }
          }
          return true;
        });
      }
    }
    // code for multiselect end

    // code for radioButton
    if (Type === 2 || Type === 4) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          if (item.answerId === recentAnswer[0]) {
            if (item.moveToNextQuestion === 0) {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }
            if (item.isQualify === 0) {
              isQualify.push({ isQualify: false, answerID: item.answerId });
            }
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: userid,
              value: item.answerText,
              eligibilityAnswerId: item.answerId,
              optionalNotesData : item.optionalNotesData
            });
          }
        }
        return true;
      });
    }
    // end for radiobutton

    // code for Inputbox
    if (Type === 3) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          ansArray.push({
            eligibilityQuestionId: questionId,
            userId: userid,
            value: recentAnswer,
            eligibilityAnswerId: item.answerId,
            optionalNotesData : item.optionalNotesData,
            
          });
        }
        return true;
      });
    }
    // end for Inputbox

    // code for multiple input
    if (Type === 7) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item, index) => {
        if (item.isDisabled !== 1) {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          ansArray.push({
            eligibilityQuestionId: questionId,
            userId: userid,
            value: recentAnswer[index],
            eligibilityAnswerId: item.answerId,
            optionalNotesData:item.optionalNotesData
          });
        }
        return true;
      });
    }
    // end for multiple input

    // code for vehicle and type 8
    if (Type === 8) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      for (let i = 0; i < recentAnswer.length; i++) {
        answerOptions.map((item) => {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          ansArray.push({
            eligibilityQuestionId: questionId,
            userId: userid,
            value: item.answerText,
            eligibilityAnswerId: item.answerId,
            optionalNotesData:item.optionalNotesData
          });
          return true;
        });
      }
    }
    if (Type === 9) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          ansArray.push({
            eligibilityQuestionId: questionId,
            userId: userid,
            value: "",
            eligibilityAnswerId: item.answerId,
            optionalNotesData:item.optionalNotesData
          });
        }
        return true;
      });
    }
    // code for number input
    if (Type === 6) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          const answer = item.answerText;
          let matchProperty = [];
          matchProperty = answer.split(",");
          if (matchProperty.indexOf(recentAnswer) === -1) {
            isMatch.push({ matchValue: false, answerID: item.answerId });
          }
          // if (item.moveToNextQuestion === 0) {
          //   moveToNextFlag.push({
          //     moveToNextQuestion: false,
          //     answerID: item.answerId,
          //   });
          // }

          if (item.moveToNextQuestion === 0) {
            if (
              item.matchValue === 1 &&
              item.answerText.includes(recentAnswer) === true
            ) {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }
          } else if (
            item.matchValue === 1 &&
            item.answerText.includes(recentAnswer) === false
          ) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          // moveToNextFlag.push({ moveToNextQuestion: false, answerID: item.answerId });

          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          ansArray.push({
            eligibilityQuestionId: questionId,
            userId: userid,
            value: recentAnswer,
            eligibilityAnswerId: item.answerId,
            optionalNotesData : item.optionalNotesData
          });
        }
        return true;
      });
    }
    // end for number input

    if (moveToNextFlag.length > 0) {
      this.setState({
        PopErrorNotAllowedToMove: true,
        moveToNextFlag: [],
        settlementId,
        recentAnswer: [],
      });
      this.props.saveUsersUneligibleSettlements({
        settlementId,
        userId: userid,
      });
    } else {
      let PopErrorNotAllowedToMove = false;
      // const status = false;
      if (Type === 6) {
        if (isMatch.length > 0) {
          this.setState({
            // PopErrorNotAllowedToMove: true,
            recentAnswer: [],
          });
        }
        // true;
      } else {
        PopErrorNotAllowedToMove = false;
      }
      LocalAnswerObj.eligibilityQuestionResponseDtos = ansArray;
      mainSubAnswerArray.push(LocalAnswerObj);
      answerObj.eligibilityQuestionDtoList = mainSubAnswerArray;
      if (!PopErrorNotAllowedToMove) {
        this.props.AddTheFinalAnswer(answerObj);
      }
    }
    return true;
  }

  dismissSettlement(settlementId) {
    if (settlementId === "hide") {
      this.props.change();
      // const data = {
      //   id: settlementId,
      //   userId: localStorage.getItem('userId'),
      //   dismissSettlement: 'Y', // Y for dismiss and N for undismiss
      // };
      this.setState({
        openVehiclePop: false,
      });
      // this.props.requestDismissSettlement(data);
      this.props.sendData();
    } else {
      const data = {
        id: settlementId,
        userId: localStorage.getItem("userId"),
        dismissSettlement: "Y", // Y for dismiss and N for undismiss
      };
      this.props.requestDismissSettlement(data);
      this.props.sendData();
    }
  }

  dismissSettlementT(settlementId) {
    const data = {
      id: settlementId,
      userId: localStorage.getItem("userId"),
      dismissSettlement: "N", // Y for dismiss and N for undismiss
    };
    this.props.requestDismissSettlement(data);
    this.props.sendData();
  }

  /**
   * Open dialog
   */
  handleClickOpen = () => {
    this.setState({
      openInfoDialog: true,
    });
  };

  // componentWillUnmount() {
  //   console.log('this.props.data.setFilteredDSettlement.records && this.props.data.setFilteredDSettlement.records.length', this.props.data.setFilteredDSettlement.records && this.props.data.setFilteredDSettlement.records.length)
  //   if(this.props.data.setFilteredDSettlement.records && this.props.data.setFilteredDSettlement.records.length < 1) {
  //     localStorage.removeItem("showTutorial")
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    // console.log('dates',dates);
    // const dates = nextProps.claimPeriodEndDate
    //   ? nextProps.claimPeriodEndDate
    //   : '';
    const ReciveSettlmentanswersResponse = nextProps.data
      .ReciveSettlmentanswersResponse
      ? nextProps.data.ReciveSettlmentanswersResponse
      : {};
    if (Object.keys(ReciveSettlmentanswersResponse).length > 0) {
      this.setState({
        // closedQuitionair: true,
      });
    }
  }

  /**
   * Close delete dialog
   */
  handleClose = () => {
    this.setState({ openInfoDialog: false });
  };

  handleSuccessChange = () => {
    this.props.change();
  };

  handleFundsClosePop = () => {
    this.setState({
      openFundsPop: false,
    });
  };
  handleFundsOpenPop = () => {
    this.setState({
      openFundsPop: true,
    });
  };
  // static getd

  render() {
    const {
      name,
      dashboardIntroText,
      enrId,
      price,
      tbdAmount,
      item,
      applyButtonDisplay,
      cat,
      isShow,
      type,
      dismissOption,
      searchType,
      requiredDoc,
      automotiveSettlements,
      disbursedAmount,
      breakdownFund,
    } = this.props;
    const {
      settlementDocumentDtoList1,
      PopErrorNotAllowedToMove,
      settlementId,
      error,
    } = this.state;
    let QuestionList = [];
    QuestionList = this.props.questionToDO;
    // let claimPeriodStartSelected = '';
    let claimPeriodEndSelected = "";
    let caseApprovalSelected = "";
    let optOutDeadlineSelected = "";
    let fairnessHearingSelected = "";
    let fundsInEscrowSelected = "";
    let fundsDisbursementSelected = "";
    let caseUnderAppealSelected = ""
    // console.log('PopErrorNotAllowedToMoveStatus',PopErrorNotAllowedToMove, settlementId, enrId)
    // const hideclaimPeriodStartSelected = '';
    // let optOutDeadlineSelectedinvestigation = '';
    // let optOutDeadlineSelectedL = '';
    // let diffDayguiltyPleaD = '';
    // let diffDayguiltyPleaDinitialApproval = '';
    // let settlementD = '';
    // let optOutDeadlineSelectedLclassAction = '';
    // let caseApprovalSelectedclassPeriodStart = '';
    // let caseApprovalSelectedclassPeriodEnd = '';
    // const hideclaimPeriodEndSelected = '';
    // let hidecaseApprovalSelected = '';
    // let hideoptOutDeadlineSelected = '';
    // let hidefairnessHearingSelected = '';
    // let hidefundsInEscrowSelected = '';
    // let hidefundsDisbursementSelected = '';
    let applyButton;
    let uploadButton;
    let applyDocument;
    let updateSettlementButtons;
    console.log("cat", cat);
    if (item !== undefined) {
      if (settlementDocumentDtoList1 !== item.settlementDocumentDtoList) {
        this.setState({
          settlementDocumentDtoList1: item.settlementDocumentDtoList,
        });
      }
    }
    let enrollStatus = "";
    if (type === 'enrollment') {
    if (type) {
      enrollStatus = item.statusName;
      if( cat === "enrolledCompleted" ) {    //1|| cat === "completeSettlementData"
        applyButton = (

          <div className="btn-float-left">
            <button
              className="waves-light btn btn-blue save-changes"
            >
              {/* funds Disbursed - ${disbursedAmount} */}
            </button>
          </div>
        );
      } else {
      applyButton = (
        <div className="btn-float-left">
          <button
            className="waves-light btn btn-blue save-changes"
            onClick={this.handleReviewOpen}
          >
            Review
          </button>
        </div>
      );
    }
      }
    }
    if (
      (type === "settlement" || applyButtonDisplay === true) &&
      QuestionList !== undefined && QuestionList.length !== 1
    ) {
      applyButton = (
        <div className="col s12 right-align apply-btn">
          {/* <div className = "hover-bg"></div> */}
          {/* <div className="apl-btn-top"> */}
          <div
            className={
              (this.state.tutorialPopupState1 == true &&
                this.props.index == 0) ||
              (this.props.data.tutorialPopupStateAction.tutorialPopupState ==
                true &&
                this.state.tutorialPopupState1 == false)
                ? "apl-btn-top apl-btn-up"
                : "apl-btn-top"
            }
          >
            {this.state.tutorialPopupState1 == true ? (
              this.props.index == 0 ? (
                <div class="box-arrow arrow-right">
                  <div className="top-bl">
                    <h3>Welcome to Collectively</h3>
                    <p>Let’s show you how this works.</p>
                  </div>
                  <div className="bottom-wt">
                    <h3>How to Enroll</h3>
                    <p>Simply click <b>Apply</b> to enroll with Collectively.</p>
                  </div>
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {/* <div className={(this.state.tutorialPopupState1 == true) || (this.props.data.tutorialPopupStateAction.tutorialPopupState == true && this.state.tutorialPopupState1 == false) ? "" : "over"}> */}
            <div className="Click-here-wt">
            <Link
              disabled={
                this.props.applySettelment >= 1
                  ? false
                  : this.props.applySettelmentStatus !== "Started"
              }
              className="waves-light btn btn-blue save-changes"
              to={`/apply/${enrId}`}
            >
              Click Here to Apply
            </Link>
            </div>
          </div>
        </div>
      );
      enrollStatus = item.statusName;
    } else if (type === "enrollment"  ) {
      if( cat === "enrolledCompleted" || cat === "completeSettlementData") {    //2  || cat === "completeSettlementData"
        applyButton = (

          <div className="btn-float-left">
            <button
              className="btn waves-effect waves-light primary-btn right"
              onClick={this.handleFundsOpenPop}
            >
              funds Disbursed -  ${disbursedAmount != null ? disbursedAmount : "0" }
              {/* funds Disbursed - ${disbursedAmount} */}
            </button>
          </div>
        );
      } else {
      enrollStatus = item.statusName;
      applyButton = (
        <div className="btn-float-left">
          <button
            className="waves-light btn btn-blue save-changes"
            onClick={this.handleReviewOpen}
          >
            Review
          </button>
        </div>
      );
      }
      if (requiredDoc === "upload") {
        uploadButton = (
          <div className="btn-float-left">
            <Link
              className="waves-light btn btn-blue save-changes apply-btn-dialog "
              to={`/apply-document/${enrId}`}
            >
              funds Disbursed - $
              {disbursedAmount ? disbursedAmount.toFixed(2) : 0.0}
            </Link>
          </div>
        );
      } else if (requiredDoc === "review") {
        applyDocument = (
          <div className="btn-float-left">
            <button
              className='waves-light btn btn-blue save-changes'
              onClick={this.handleReviewOpen}
            >
              Review
            </button>
          </div>
        );
      }
      if (cat !== 'enrolledCompleted') {   // 3||cat !== "completeSettlementData"
        if (requiredDoc === 'upload') { 
          uploadButton = (
            <div className='btn-float-left'>
              <Link
                className='waves-light btn btn-blue save-changes apply-btn-dialog '
                to={`/apply-document/${enrId}`}
              >
                Upload Documents
              </Link>
            </div>
          );
        } else if (requiredDoc === 'review') {
          applyDocument = (
            <div className='btn-float-left'>
              <button
                className='waves-light btn btn-blue save-changes'
                onClick={this.handleReviewDoc}
              >
                Review Documents
              </button>
            </div>
          );
        }
      }
    } else {
      applyButton = "";
      uploadButton = "";
    }

    let dismissButton = "";
    if (
      this.props.settlementTypeStatus !== "STARTED" &&
      this.props.settlementTypeStatus !== "FEATURED"
    ) {
      if (dismissOption) {
        if (searchType === "Dismiss") {
          dismissButton = (
            <div className="dismitt-button">
              {" "}
              <div className="apply-btn">
                <a
                  className='settlement-relevant save-changes'
                  onClick={() => this.dismissSettlementT(enrId)}
                >
                  <span className="hide hide-seetlementtext">Show&nbsp;</span>
                  <i className="material-icons show-settlement-icon">
                    visibility_on
                  </i>
                </a>
              </div>
            </div>
          );
        } else {
          dismissButton = (
            <div className='dismitt-button'>
              <div className='apply-btn'>
                <a
                  className='settlement-relevant save-changes'
                  onClick={() => this.dismissSettlement(enrId)}
                >
                  <span className="hide hide-seetlementtext">Hide&nbsp;</span>{" "}
                  <i className="material-icons">visibility_off</i>
                </a>
              </div>
            </div>
          );
        }
      }
    }
    if (cat === "automotiveSettlements") {
      if (automotiveSettlements === "automotiveSettlements") {
        updateSettlementButtons = (
          <div className='automotive-settlement'>
            <h6>
              HAVE YOU PURCHASED OR LEASED A VEHICLE IN THE LAST 25 YEARS?
            </h6>

            <div className='vehicle-introbutton'>
              <button onClick={this.openModalVehicle} type='button'>
                Yes
                {/* I have purchased or leased a vehicle in the last 25 years. */}
              </button>
              <button onClick={this.openModalVehiclePop} type="button">
                No
                {/* I do not own a vehicle, and have not in the last 25 years. */}
              </button>

              <div className='col s12 pad-none' />
              <AddVehicleInEligibility
                close={this.handleCloseModal}
                open={this.state.openComponents}
                successSave={this.handleSuccessChange}
              />
            </div>
          </div>
        );
      } else {
        applyButton = "";
        uploadButton = "";
      }
    }
    if (
      cat === "attentionSettlementData" ||
      // cat === "completeSettlementData" ||
      cat === "enrollSettlementForUserData" ||
      cat === "needAttentionSettlemnt"
    ) {
      applyButton = (
        <div className='btn-float-left'>
          <button
            className='waves-light btn btn-blue save-changes'
            onClick={this.handleReviewOpen}
          >
            Review
          </button>
        </div>
      );
      if (requiredDoc === "upload") {
        if (item.settlementRequiredDocumentDtoList.length === 0) {
          uploadButton = "";
        } else {
          uploadButton = (
            <div className='btn-float-left'>
              <Link
                className='waves-light btn btn-blue save-changes apply-btn-dialog '
                to={`/apply-document/${enrId}`}
              >
                Upload Documents
              </Link>
            </div>
          );
        }
      } else if (requiredDoc === "review") {
        applyDocument = (
          <div className='btn-float-left'>
            <button
              className='waves-light btn btn-blue save-changes'
              onClick={this.handleReviewDoc}
            >
              Review Documents
            </button>
          </div>
        );
      } else {
        uploadButton = "";
      }
    } else {
      // applyButton = '';
    }
    const currentData = new Date();
    const dateInfoSeq = [];
    const ShowDate = [];

    if (typeof item !== "undefined") {
      if (typeof item.settlementImportantDateDto !== "undefined") {
        // console.log(item.settlementImportantDateDto)
        const claimPeriodStart = new Date(
          item.settlementImportantDateDto.claimPeriodStart
        );
        const timeDiff = currentData - claimPeriodStart;
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays > 0) {
          // claimPeriodStartSelected = 'selected';
        }
        // if (item.settlementImportantDateDto.hideClaimPeriodStart === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Claim Filing Start',"hide":"hideclaimPeriodStartSelected","claim":claimPeriodStartSelected,"date":item.settlementImportantDateDto.claimPeriodEnd})
        // }

        const claimPeriodEnd = new Date(
          item.settlementImportantDateDto.claimPeriodEnd
        );
        const timeDiffclaimPeriodEnd = currentData - claimPeriodEnd;
        const diffDaysclaimPeriodEnd = Math.ceil(
          timeDiffclaimPeriodEnd / (1000 * 3600 * 24)
        );
        if (diffDaysclaimPeriodEnd > 0) {
          claimPeriodEndSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideClaimPeriodEnd === 1) {
          // empty
        } else if (item.settlementImportantDateDto.claimPeriodEnd !== "") {
          dateInfoSeq.push({
            title: "Claim Filing Deadline",
            hide: "hideclaimPeriodStartSelected",
            claim: claimPeriodEndSelected,
            date: item.settlementImportantDateDto.claimPeriodEnd,
          });
        }

        // classPeriodStart
        const classPeriodStart = new Date(
          item.settlementImportantDateDto.classPeriodStart
        );
        const timeDiffcaseclassPeriodStart = currentData - classPeriodStart;
        const diffDayscaseclassPeriodStart = Math.ceil(
          timeDiffcaseclassPeriodStart / (1000 * 3600 * 24)
        );
        if (diffDayscaseclassPeriodStart > 0) {
          // caseApprovalSelectedclassPeriodStart = 'selected';
        }
        const classPeriodEnd = new Date(
          item.settlementImportantDateDto.classPeriodEnd
        );
        const timeDiffcaseApprovalclassPeriodEnd = currentData - classPeriodEnd;
        const diffDayscaseApprovalclassPeriodEnd = Math.ceil(
          timeDiffcaseApprovalclassPeriodEnd / (1000 * 3600 * 24)
        );
        if (diffDayscaseApprovalclassPeriodEnd > 0) {
          // caseApprovalSelectedclassPeriodEnd = 'selected';
        }

        const caseApproval = new Date(
          item.settlementImportantDateDto.caseApproval
        );
        const timeDiffcaseApproval = currentData - caseApproval;
        const diffDayscaseApproval = Math.ceil(
          timeDiffcaseApproval / (1000 * 3600 * 24)
        );

        if (diffDayscaseApproval > 0) {
          caseApprovalSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideCaseApproval === 1) {
          // hidecaseApprovalSelected = 1;
        } else if (item.settlementImportantDateDto.caseApproval !== "") {
          dateInfoSeq.push({
            title: "Final Approval",
            hide: "hidecaseApprovalSelected",
            claim: caseApprovalSelected,
            date: item.settlementImportantDateDto.caseApproval,
          });
        }

        const optOutDeadline = new Date(
          item.settlementImportantDateDto.optOutDeadline
        );
        const timeDiffoptOutDeadline = currentData - optOutDeadline;
        const diffDaysoptOutDeadline = Math.ceil(
          timeDiffoptOutDeadline / (1000 * 3600 * 24)
        );
        if (diffDaysoptOutDeadline > 0) {
          optOutDeadlineSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideOptOutDeadline === 1) {
          // hideoptOutDeadlineSelected = 1;
        } else if (item.settlementImportantDateDto.optOutDeadline !== "") {
          dateInfoSeq.push({
            title: "Opt-Out Deadline",
            hide: "hidecaseApprovalSelected",
            claim: optOutDeadlineSelected,
            date: item.settlementImportantDateDto.optOutDeadline,
          });
        }
        // investigation
        const investigation = new Date(
          item.settlementImportantDateDto.investigation
        );
        const timeDiffoptOutDeadlineinvestigation = currentData - investigation;
        const diffDaysoptOutDeadlineinvestigation = Math.ceil(
          timeDiffoptOutDeadlineinvestigation / (1000 * 3600 * 24)
        );
        if (diffDaysoptOutDeadlineinvestigation > 0) {
          // optOutDeadlineSelectedinvestigation = 'selected';
        }
        if (item.settlementImportantDateDto.hideInvestigation === 1) {
          // hideoptOutDeadlineSelected = 1;
        } else {
          // hideoptOutDeadlineSelected = 0;
          // dateInfoSeq.push({"title":'Investigation',"hide":"hidecaseApprovalSelected","claim":optOutDeadlineSelectedinvestigation,"date":item.settlementImportantDateDto.investigation})
        }

        const classAction = new Date(
          item.settlementImportantDateDto.classAction
        );
        const timeDiffoptOutDeadlineclassAction = currentData - classAction;
        const diffDaysoptOutDeadlineClass = Math.ceil(
          timeDiffoptOutDeadlineclassAction / (1000 * 3600 * 24)
        );
        if (diffDaysoptOutDeadlineClass > 0) {
          // optOutDeadlineSelectedLclassAction = 'selected';
        }
        // if (item.settlementImportantDateDto.hideClassAction === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Class Action',"hide":"hidecaseApprovalSelected","claim":optOutDeadlineSelectedLclassAction,"date":item.settlementImportantDateDto.classAction})
        // }
        const litigation = new Date(item.settlementImportantDateDto.litigation);
        const timeDiffoptOutDeadlinelitigation = currentData - litigation;
        const diffDaysoptOutDeadlinel = Math.ceil(
          timeDiffoptOutDeadlinelitigation / (1000 * 3600 * 24)
        );
        if (diffDaysoptOutDeadlinel > 0) {
          // optOutDeadlineSelectedL = 'selected';
        }
        // if (item.settlementImportantDateDto.hideLitigation === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Litigation',"hide":"hidecaseApprovalSelected","claim":optOutDeadlineSelectedL,"date":item.settlementImportantDateDto.litigation})
        // }

        const guiltyPlea = new Date(item.settlementImportantDateDto.guiltyPlea);
        const timeDiffoptOutguiltyPlea = currentData - guiltyPlea;
        const diffDayguiltyPlea = Math.ceil(
          timeDiffoptOutguiltyPlea / (1000 * 3600 * 24)
        );
        if (diffDayguiltyPlea > 0) {
          // diffDayguiltyPleaD = 'selected';
        }
        // if (item.settlementImportantDateDto.hideGuiltyPlea === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Guilty Plea',"hide":"hidecaseApprovalSelected","claim":diffDayguiltyPleaD,"date":item.settlementImportantDateDto.guiltyPlea})
        // }
        // settelment
        const settlement = new Date(item.settlementImportantDateDto.settlement);
        const settlementP = currentData - settlement;
        const diffDayguiltyPleasettlementP = Math.ceil(
          settlementP / (1000 * 3600 * 24)
        );
        if (diffDayguiltyPleasettlementP > 0) {
          // settlementD = 'selected';
        }
        // if (item.settlementImportantDateDto.hideSettlement === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Settlement',"hide":"hidecaseApprovalSelected","claim":settlementD,"date":item.settlementImportantDateDto.settlement})
        // }
        // const initialApproval = new Date(
        //   item.settlementImportantDateDto.initialApproval,
        // );
        const timeDiffoptOutguiltyPleainitialApproval =
          currentData - guiltyPlea;
        const diffDayguiltyPleainitialApproval = Math.ceil(
          timeDiffoptOutguiltyPleainitialApproval / (1000 * 3600 * 24)
        );
        if (diffDayguiltyPleainitialApproval > 0) {
          // diffDayguiltyPleaDinitialApproval = 'selected';
        }
        // if (item.settlementImportantDateDto.hideInitialApproval === 1) {
        // } else {
        //   // dateInfoSeq.push({"title":'Initial Approval',"hide":"hidecaseApprovalSelected","claim":diffDayguiltyPleaDinitialApproval,"date":item.settlementImportantDateDto.initialApproval})
        // }

        const fairnessHearing = new Date(
          item.settlementImportantDateDto.fairnessHearing
        );
        const timeDifffairnessHearing = currentData - fairnessHearing;
        const diffDaysfairnessHearing = Math.ceil(
          timeDifffairnessHearing / (1000 * 3600 * 24)
        );
        if (diffDaysfairnessHearing > 0) {
          fairnessHearingSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideFairnessHearing === 1) {
          // hidefairnessHearingSelected = 1;
        } else if (item.settlementImportantDateDto.fairnessHearing !== "") {
          dateInfoSeq.push({
            title: "Fairness Hearing",
            hide: "hidecaseApprovalSelected",
            claim: fairnessHearingSelected,
            date: item.settlementImportantDateDto.fairnessHearing,
          });
        }

        const fundsInEscrow = new Date(
          item.settlementImportantDateDto.fundsInEscrow
        );
        const timeDifffundsInEscrow = currentData - fundsInEscrow;
        const diffDaysfundsInEscrow = Math.ceil(
          timeDifffundsInEscrow / (1000 * 3600 * 24)
        );
        if (diffDaysfundsInEscrow > 0) {
          fundsInEscrowSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideFundsInEscrow === 1) {
          // hidefundsInEscrowSelected = 1;
        } else if (item.settlementImportantDateDto.fundsInEscrow !== "") {
          dateInfoSeq.push({
            title: "Funds in Escrow",
            hide: "hidecaseApprovalSelected",
            claim: fundsInEscrowSelected,
            date: item.settlementImportantDateDto.fundsInEscrow,
          });
        }

        const caseUnderAppeal = new Date(
          item.settlementImportantDateDto.caseUnderAppeal
        );
        const timeDiffCaseUnderAppeal= currentData - caseUnderAppeal;
        const diffDaysCaseUnderAppeal = Math.ceil(
          timeDiffCaseUnderAppeal / (1000 * 3600 * 24)
        );
        if (diffDaysCaseUnderAppeal > 0) {
          caseUnderAppealSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideCaseUnderAppeal === 1) {
          // hidefundsInEscrowSelected = 1;
        } else if (item.settlementImportantDateDto.caseUnderAppeal !== "") {
          dateInfoSeq.push({
            title: "Case Under Appeal",
            hide: "hidecaseApprovalSelected",
            claim: caseUnderAppealSelected,
            date: item.settlementImportantDateDto.caseUnderAppeal,
          });
        }

        const fundsDisbursement = new Date(
          item.settlementImportantDateDto.fundsDisbursement
        );
        const timeDifffundsDisbursement = currentData - fundsDisbursement;
        const diffDaysfundsDisbursement = Math.ceil(
          timeDifffundsDisbursement / (1000 * 3600 * 24)
        );
        if (diffDaysfundsDisbursement > 0) {
          fundsDisbursementSelected = "selected";
        }
        if (item.settlementImportantDateDto.hideFundsDisbursement === 1) {
          // hidefundsDisbursementSelected = 1;
        } else if (item.settlementImportantDateDto.fundsDisbursement !== "") {
          dateInfoSeq.push({
            title: "Funds Disbursement",
            hide: "hidecaseApprovalSelected",
            claim: fundsDisbursementSelected,
            date: item.settlementImportantDateDto.fundsDisbursement,
          });
        }

        dateInfoSeq.sort((a, b) => {
          const dateA = new Date(a.date);

          const dateB = new Date(b.date);
          return dateA - dateB;
        });
        dateInfoSeq.map((itemDate, index) => {
          ShowDate.push(
            <li key={index} className={itemDate.claim}>
              <span />
              {itemDate.title}
            </li>
          );
          return true;
        });
        // console.log("dateInfoSeq",dateInfoSeq)
      }
    }
    let catText = "";
    if (
      isShow ||
      cat === "attentionSettlementData" ||
      cat === "completeSettlementData" ||
      cat === "enrolledInProgress" ||
      cat === "featureSettlementData" ||
      cat === "needAttention" ||
      cat === "completed" ||
      cat === "enrolledCompleted" ||
      cat === "enrollSettlementForUserData" ||
      cat === "allSettlementData" ||
      cat === "needAttentionSettlemnt" 
    ) {
      if (cat === "allSettlementData") {
        catText = "New Settlement";
      }
      if (cat === "promotoSettlementData") {
        catText = "Featured Settlement";
      }
      if (cat === "automotiveSettlements") {
        catText = "New Settlement";
      }
      if (cat === "featureSettlementData") {
        catText = "Eligibility Match";
      }
      if (cat === "attentionSettlementData") {
        catText = "Needs Attention";
      }
      if (cat === "completeSettlementData") {
        catText = "Completed";                //rendered
      }
      if (cat === "enrollSettlementForUserData") {
        catText = "In Progress";
      }
      if (cat === "enrolledInProgress") {
        catText = "In Progress";
      }
      if (cat === "needAttention") {
        catText = "Needs Attention";
      }
      if (cat === "completed") {
        catText = "Completed";
      }
      if (cat === "needAttentionSettlemnt") {
        catText = "Needs Attention";
      }

      if (cat === 'enrolledCompleted') {
        catText = 'Completed';
      }
    }

    let patti = "";
    if (type !== "settlement") {
      patti = (
        <div
          className={
            cat === "allSettlementData" ||
            cat === "featureSettlementData" ||
            cat === "promotoSettlementData"
              ? "status-bar col s12 m12 hide"
              : "status-bar col s12 m12"
          }
        >
          <ul className='timeline-Display'>{ShowDate}</ul>
        </div>
      );
    }

    const theCurrentQuestion = 0;
    const currentQuestionBody = [];
    let QuesType = "";
    if (QuestionList !== undefined && QuestionList.length > 0) {
      QuesType = QuestionList[theCurrentQuestion].questionTypeId;
      //   if(QuestionList.length >7){
      // console.log('  console.log',QuestionList[theCurrentQuestion].questionTypeId);
      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 1
      ) {
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((item1, index) => {
          // console.log('AnswerOptions',item);
          if (item1.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <a
                  className={
                    this.state.recentAnswer.indexOf(item1.answerId) > -1
                      ? "button active"
                      : "button"
                  }
                  onClick={() => this.MultiselectOptions(item1.answerId)}
                >
                  {item1.answerText}
                </a>
              </span>
            );
          }
          return true;
        });
        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={options}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        (QuestionList[theCurrentQuestion].questionTypeId === 2 ||
          QuestionList[theCurrentQuestion].questionTypeId === 4)
      ) {
        // console.log('QuestionInfo',QuestionList[currentQuestionNumber]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((itemAnswer, index) => {
          // console.log('AnswerOptions',item);
          if (itemAnswer.isDisabled !== 1) {
            options.push(
              <span
                className="radio-seetmentbutton question-btn-yes"
                key={index}
              >
                <a
                  className={
                    this.state.recentAnswer.indexOf(itemAnswer.answerId) > -1
                      ? "button active"
                      : " button"
                  }
                  onClick={() => this.radioSelectOption(itemAnswer.answerId)}
                >
                  {itemAnswer.answerText}
                </a>
              </span>
            );
          }
          return true;
        });

        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={options}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 3
      ) {
        // console.log('QuestionInfo',QuestionList[currentQuestionNumber-1]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((itemA, index) => {
          // console.log('AnswerOptions',item);
          if (itemA.isDisabled !== 1) {
            options.push(
              <span className='multiple-inputboxquestion' key={index}>
                <input
                  type='text'
                  name='recentAnswer'
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptions}
                />
              </span>
            );
          }
          return true;
        });
        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}   
              QuestionOptions={options}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 5
      ) {
        // console.log('QuestionInfo',QuestionList[currentQuestionNumber-1]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        let dropdown = "";
        options.push({
          value: "",
          label: "select Option",
          name: "select Option",
        });
        AnswerOptions.map((item5) => {
          if (item5.isDisabled !== 1) {
            return options.push({
              value: item5.answerId,
              label: item5.answerText,
              name: item5.answerText,
            });
          }
          return true;
        });
        // selecting the first index to select
        const selectedArra = _.find(options, {
          value: this.state.recentAnswer[0],
        });
        const defaultOption = selectedArra;
        dropdown = (
          <Dropdown
            name='optionsDropdown'
            className='browser-default'
            options={options}
            onChange={this._onSelect}
            value={defaultOption}
            placeholder='Select an option'
          />
        );

        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={dropdown}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 6
      ) {
        // console.log('AnswerOptions',QuestionList[currentQuestionNumber-1]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((item6, index) => {
          if (item6.isDisabled !== 1) {
            options.push(
              <span className="question-counter" key={index}>
                <span
                  className="question-number minus"
                  onClick={this.inputSelctorOptionsSub}
                >
                  -
                </span>
                <input
                  type='number'
                  name='recentAnswer'
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptionsNumber}
                />
                <span
                  className="question-number plus"
                  onClick={this.inputSelctorOptionsAdd}
                >
                  +
                </span>
              </span>
            );
          }
          return true;
        });
        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={options}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 7
      ) {
        //  console.log('AnswerOptions',QuestionList[currentQuestionNumber]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((item7, index) => {
          if (item7.isDisabled !== 1) {
            options.push(
              <span className="muliplelable-settlementquestions" key={index}>
                <label className="multiple-line-input">
                  {item7.answerText}
                </label>
                <input
                  type='text'
                  name='recentAnswer'
                  onBlur={this.multipleInputOptions}
                  placeholder=''
                  key={index}
                />
              </span>
            );
          }
          return true;
        });
        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={options}
            />
          </span>
        );
      }

      if (
        QuestionList[theCurrentQuestion] !== undefined &&
        QuestionList[theCurrentQuestion].questionTypeId === 9
      ) {
        // console.log('QuestionInfo',QuestionList[currentQuestionNumber-1]);
        const QuestionInfo = QuestionList[theCurrentQuestion];
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const options = [];
        AnswerOptions.map((item9, index) => {
          // console.log('AnswerOptions',item);
          if (item9.isDisabled !== 1) {
            options.push(
              <span
                style={{ display: "none" }}
                className="multiple-inputboxquestion"
                key={index}
              >
                <input
                  type='text'
                  name='recentAnswer'
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptions}
                />
              </span>
            );
          }
          return true;
        });
        currentQuestionBody.push(
          <span key='q1'>
            <QuestionComponent
              questionText={questionText}
              QuestionOptions={options}
            />
          </span>
        );
      }
    }

    return (
      <span>
        {this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == true
          ? document.addEventListener("mousedown", this.handleClickOutside4)
          : ""}
        {this.props.data.tutorialPopupStateAction5.tutorialPopupState5 == true
          ? document.addEventListener("mousedown", this.handleClickOutside5)
          : ""}
        {this.props.data.tutorialPopupStateAction2.tutorialPopupState2 == true
          ? document.addEventListener("mousedown", this.handleClickOutside2)
          : ""}
        {this.props.data.tutorialPopupStateAction3.tutorialPopupState3 == true
          ? document.addEventListener("mousedown", this.handleClickOutside3)
          : ""}
        {
        localStorage.getItem("roleName") == "Business-User"
        ?
        this.props.data.tutorialPopupStateAction2.tutorialPopupState2 ==
        true ? (
          <div>
            <div className="side-my-profile">My Profile</div>
            <div class="box-arrow arrow-left adding-ein">
              <div className="bottom-wt">
                <h3>Adding EINs</h3>
                <p>
                  To add users or EINs, visit <b>My Profile</b>.
                </p>
              </div>
              <div className="top-bl you-are">

                <h3>You’re Ready to Go</h3>
          <p>
            For additional questions, visit <b> Help</b> to review FAQs.
          </p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )
      : ""
      }
{ this.props.data.tutorialPopupStateAction5.tutorialPopupState5 == true ?
      <div class="box-arrow arrow-right tutorial-5">
        <div className="top-bl">
        <h3>You’re ready to go!</h3>
                <p>
                  For other questions, visit <b> Help</b> to review FAQs.
                </p>
        </div>
      </div> : ""}
        <Dialog
          open={this.state.openFundsPop}
          onClose={this.handleFundsClosePop}
          aria-labelledby='form-dialog-title'
          maxWidth='md'
          disableBackdropClick
        >
          <DialogTitle id='form-dialog-title'>Funds Breakdown</DialogTitle>
          <DialogContent>
            <p>
              Enrollee Funds: $
              {breakdownFund && breakdownFund.userAmount
                ? breakdownFund.userAmount.toFixed(2)
                : 0.0}
            </p>
            <p>
              Collectively Commission: $
              {breakdownFund && breakdownFund.collectivelyCommissionAmount
                ? breakdownFund.collectivelyCommissionAmount.toFixed(2)
                : 0.0}
            </p>
            {/* {console.log(
              'this.props======',
              this.props.data.ConsumerUserData.affiliateId
            )} */}
            {this.props.data.ConsumerUserData &&
            this.props.data.ConsumerUserData.affiliateId === 0
              ? ''
              : ''
              // : `Partner Commission (if user registered through a partner): $${
              //     breakdownFund && breakdownFund.partnerCommissionAmount
              //       ? breakdownFund.partnerCommissionAmount.toFixed(2)
              //       : 0.0
              //   }`
                }
            {/* Partner Commission (if user registered through a partner): $
            {breakdownFund && breakdownFund.partnerCommissionAmount
              ? breakdownFund.partnerCommissionAmount.toFixed(2)
              : 0.0} */}
            <p></p>
          </DialogContent>
          <DialogActions>
            <a
              onClick={this.handleFundsClosePop}
              className='waves-light btn btn-blue save-changes apply-btn-dialog'
            >
              Cancel
            </a>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openVehiclePop}
          onClose={this.handleVehiclClosePop}
          aria-labelledby='form-dialog-title'
          maxWidth='md'
          disableBackdropClick
        >
          <DialogTitle id="form-dialog-title">
            Automotive Settlement
          </DialogTitle>
          <DialogContent>
            <p>
              Are you sure that you have not owned a vehicle in the last 25
              years?
            </p>
          </DialogContent>
          <DialogActions>
            <a
              onClick={this.handleVehiclClosePop}
              className='waves-light btn btn-blue save-changes apply-btn-dialog'
            >
              No
            </a>
            <a
              className="waves-light btn btn-blue save-changes apply-btn-dialog "
              onClick={() => this.dismissSettlement("hide")}
            >
              Yes
            </a>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openReviewDialog}
          onClose={this.handleReviewClose}
          aria-labelledby='form-dialog-title'
          maxWidth='md'
          disableBackdropClick
        >
          <DialogTitle id='form-dialog-title'>Review Enrollment</DialogTitle>
          <DialogContent>
            <p>
              Please note that{" "}
              {catText === "Needs Attention" ? "saving" : "changing"} your
              responses could alter your eligibility.
            </p>
            <p>Do you want to continue?</p>
          </DialogContent>
          <DialogActions>
            <a
              onClick={this.handleReviewClose}
              className='waves-light btn btn-blue save-changes apply-btn-dialog'
            >
              No
            </a>
            <Link
              className='waves-light btn btn-blue save-changes apply-btn-dialog '
              to={`/apply/review/${enrId}`}
            >
              Yes
            </Link>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openReviewDialogDoc}
          onClose={this.handleReviewClose}
          aria-labelledby='form-dialog-title'
          maxWidth='md'
          disableBackdropClick
        >
          <DialogTitle id="form-dialog-title">
            Review Enrollment Documents
          </DialogTitle>
          <DialogContent>
            <p>Do you want to continue?</p>
          </DialogContent>
          <DialogActions>
            <Link
              className='waves-light btn btn-blue save-changes apply-btn-dialog '
              to={`/apply-document/${enrId}`}
            >
              Yes
            </Link>

            <a
              onClick={this.handleReviewClose}
              className='waves-light btn btn-blue save-changes apply-btn-dialog'
            >
              No
            </a>
          </DialogActions>
        </Dialog>
        <li className='col s12'>
          <div className='col s12 m3 l2'>
            <div
              className={
                cat !== "automotiveSettlements"
                  ? "img-box center-align cat-image show"
                  : "hide"
              }
            >
              {typeof item !== "undefined" ? (
                <div>
                  {typeof item.categoryImage !== "undefined" ? (
                    <img src={item.categoryImage} alt="Category" />
                  ) : (
                    <img
                      src="https://s3.amazonaws.com/cappbucket/Admin/Category/cat_1.jpg"
                      alt="Category"
                    />
                  )}
                </div>
              ) : (
                <img
                  src="https://s3.amazonaws.com/cappbucket/Admin/Category/cat_1.jpg"
                  alt="Category"
                />
              )}
            </div>
            <div
              className={
                cat === "automotiveSettlements"
                  ? "img-box center-align cat-image show"
                  : "hide"
              }
            >
              <img
                src="https://s3.amazonaws.com/cappbucket/Admin/Category/cat_1.jpg"
                alt="Category"
              />

              {/* <i className="material-icons">airport_shuttle</i> */}
            </div>
            {dismissButton}
          </div>
          <div className='col s12 m9 l10'>
            <div className='tab-inner-data col s12 m9'>
              <h5>
                {name} <span>/</span>{" "}
                {tbdAmount === "TBD" ? "TBD" : <BigMoney value={price} />}
              </h5>
              {this.props.hideClaimPeriodEnd !== 1 ? (
                <a
                  className={cat !== "automotiveSettlements" ? "show" : "hide"}
                >
                  Claim Filing Deadline{" "}
                  {moment(this.props.claimPeriodEndDate).format(
                    "MM-DD-YYYY"
                  ) === "Invalid date"
                    ? "TBD"
                    : moment(this.props.claimPeriodEndDate).format(
                        "MM-DD-YYYY"
                      )}
                </a>
              ) : (
                ""
              )}
              <span
                className={cat !== "automotiveSettlements" ? "show" : "hide"}
              >
                {typeof item !== "undefined" ? (
                  <div
                    className={localStorage.getItem("showTutorial") && this.state.setFilteredDSettlementState ? "content settlement-detail-overview popup-open" : "content settlement-detail-overview"}
                    dangerouslySetInnerHTML={{ __html: item.quickOverview }}
                  >
                    {/* {parse(item.quickOverview)} */}
                  </div>
                ) : (
                  ""
                )}
              </span>

              <span
                className={cat === "automotiveSettlements" ? "show" : "hide"}
              >
                {typeof item !== "undefined" ? dashboardIntroText : ""}
              </span>
              {updateSettlementButtons}
            </div>
            <div
              className={
                cat !== "automotiveSettlements"
                  ? "col s12 m3 right-align show"
                  : "hide"
              }
            >
              <div
                className={
                  this.state.tutorialPopupState1 == true ||
                  this.props.data.tutorialPopupStateAction2
                    .tutorialPopupState2 == true ||
                  this.props.data.tutorialPopupStateAction3
                    .tutorialPopupState3 == true ||
                  this.props.data.tutorialPopupStateAction4
                    .tutorialPopupState4 == true ||
                  this.props.data.tutorialPopupStateAction5
                    .tutorialPopupState5 == true ||
                  this.props.data.tutorialPopupStateAction.tutorialPopupState ==
                    false
                    ? "hover-bg"
                    : ""
                }
              ></div>
              {this.state.tutorialPopupState1 == true ||
              this.props.data.tutorialPopupStateAction2.tutorialPopupState2 ==
                true ||
              this.props.data.tutorialPopupStateAction3.tutorialPopupState3 ==
                true ||
              this.props.data.tutorialPopupStateAction4.tutorialPopupState4 ==
                true ||
              this.props.data.tutorialPopupStateAction5.tutorialPopupState5 ==
                true ||
              this.props.data.tutorialPopupStateAction.tutorialPopupState ==
                false ? (
                  localStorage.getItem("roleName") == "Business-User" ?
                <div className="dot-links">
                  <ul>
                    <li>
                      <a>
                        <span
                          className={
                            this.state.tutorialPopupState1 == true
                              ? "dot-item active"
                              : "dot-item"
                          }
                        ></span>
                      </a>
                    </li>
                      <li>
                      <a>
                        <span
                          className={
                            this.props.data.tutorialPopupStateAction2
                              .tutorialPopupState2 == true
                              ? "dot-item active"
                              : "dot-item"
                          }
                        ></span>
                      </a>
                    </li>

                    <li>
                      <a>
                        <span
                          className={
                            this.props.data.tutorialPopupStateAction3
                              .tutorialPopupState3 == true
                              ? "dot-item active"
                              : "dot-item"
                          }
                        ></span>
                      </a>
                    </li>
                    <li>
                      <a>
                        <span
                          className={
                            this.props.data.tutorialPopupStateAction4
                              .tutorialPopupState4 == true
                              ? "dot-item active"
                              : "dot-item"
                          }
                        ></span>
                      </a>
                    </li>
                  </ul>
                </div>
              
                : 
                <div className="dot-links">
                <ul>
                  <li>
                    <a>
                      <span
                        className={
                          this.state.tutorialPopupState1 == true
                            ? "dot-item active"
                            : "dot-item"
                        }
                      ></span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span
                        className={
                          this.props.data.tutorialPopupStateAction3
                            .tutorialPopupState3 == true
                            ? "dot-item active"
                            : "dot-item"
                        }
                      ></span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span
                        className={
                          this.props.data.tutorialPopupStateAction4
                            .tutorialPopupState4 == true
                            ? "dot-item active"
                            : "dot-item"
                        }
                      ></span>
                    </a>
                  </li>
                  <li>
                    <a>
                      <span
                        className={
                          this.props.data.tutorialPopupStateAction5
                            .tutorialPopupState5 == true
                            ? "dot-item active"
                            : "dot-item"
                        }
                      ></span>
                    </a>
                  </li>
                </ul>
              </div>
                   
              
              ) : (
                ""
              )}

              <div
                className={
                  (this.props.data.tutorialPopupStateAction4
                    .tutorialPopupState4 == true &&
                    this.props.index == 0) ||
                  (this.props.data.tutorialPopupStateAction
                    .tutorialPopupState == true &&
                    this.props.data.tutorialPopupStateAction4
                      .tutorialPopupState4 == false)
                    ? "apl-btn-top arrow-Settlement-box apl-btn-up"
                    : "apl-btn-top arrow-Settlement-box"
                }
              >
                {this.props.data.tutorialPopupStateAction4
                  .tutorialPopupState4 == true &&
                this.state.tutorialPopupState1 == false ? (
                  this.props.index == 0 ? (
                    <div class="box-arrow arrow-right">
                      <div className="bottom-wt">
                        <h3>All the Details</h3>
                        <p>
                          Click <b>Settlement Details </b>to see all of the case
                          details.
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {/* <div className={(this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == true) || (this.props.data.tutorialPopupStateAction.tutorialPopupState == true && this.props.data.tutorialPopupStateAction4.tutorialPopupState4 == false) ? "" : "over"}> */}
                <div className="settlement-wt">
                <a
                  className="modal-trigger tab-detail"
                  onClick={this.handleClickOpen}
                >
                  Settlement Details{" "}
                </a>
                </div>
              </div>
              <a className="modal-trigger tab-detail clear settlement-date">
                {" "}
              </a>
              <a className="modal-trigger tab-detail">{enrollStatus} </a>
              <a
                href=""
                onClick={(e) => e.preventDefault()}
                className="modal-trigger tab-detail"
              >
                {this.state.enrolmentdate}{" "}
              </a>
            </div>
            {patti}
            <div
              className={
                this.state.closedQuitionair
                  ? "hide"
                  : this.props.applySettelment === 0
                  ? "hide"
                  : ""
              }
            >
              <div
                className={
                  !PopErrorNotAllowedToMove &&
                  QuestionList !== undefined &&
                  QuestionList.length > 0 &&
                  QuesType !== "" &&
                  QuesType !== 8
                    ? "question-cover col s12 "
                    : "hide"
                }
              >
                <span className='set-enrollment-detail'>1-STEP ENROLLMENT</span>
                {currentQuestionBody}
                <span
                  className={
                    error !== "" ? "help-block invalid inside-error" : "hide"
                  }
                >
                  {error}
                </span>
                <div className="question-submit">
                  <a
                    className="question-btn"
                    onClick={this.ProceedWithQuestion}
                  >
                    {" "}
                    Submit <i className="material-icons">arrow_forward</i>{" "}
                  </a>
                </div>
              </div>
              <div
                className={
                  PopErrorNotAllowedToMove && settlementId === enrId
                    ? "sorry-msg col s12"
                    : "hide"
                }
              >
                <h5>
                  <img width={40} height={40} src={exclamation} alt="" />
                  Sorry You are not eligible for {name}
                </h5>
                <p>
                  You do not meet the requirements to make a claim in this
                  settlement.
                  {/* <a href="" onClick={this.showQuestion}>click here </a> */}
                </p>
              </div>
            </div>
          </div>
          <div className="outerdivclass">
          <div
            className={
              cat === "needAttention" || cat === "completed"  || cat === "completeSettlementData"  || cat === "enrolledInProgress"|| cat === "enrolledCompleted"
                ? "view-all"
                : "view-all hide"
            }
          >
            {console.log('catText', catText)}
            {catText}
          </div>
          <div className='details-required'>
            <div
              className={
                cat !== "allSettlementData" &&
                cat !== "promotoSettlementData" &&
                cat !== "enrolledCompleted" &&
                cat !== "completeSettlementData" &&   
                type !== "settlement" &&
                cat !== "automotiveSettlements" &&
                cat !== "enrollSettlementForUserData" &&
                cat !== "enrolledInProgress"
                  ? "col m8 s12  "
                  : "col s8 hide-on-med-and-down hide"
              }
            >
              <h6>Details Required</h6>

              <span>
                {requiredDoc === "upload"
                  ? "We require additional responses or some important documents to complete your claim. Please click the Review or Upload Documents button to get started."
                  : "We require additional responses or some important documents to complete your claim. Please click the Review or Upload Documents button to get started."}{" "}
              </span>

              {/* <span>
                { requiredDoc === 'upload' ? 'We require some important documents to complete your claim. Click the Documents button to get started'
                  : 'We may require more information to complete your claim. Click the Review button to get started.' }
                {' '}
              </span> */}
            </div>
            <div className={cat !== "automotiveSettlements" ? "show" : "hide"}>
              {applyButton}
              {uploadButton}
              {applyDocument}
            </div>
          </div>
              {console.log('cat==================', cat)}
          
          </div>
          <div
            className={
              isShow ||
              cat === "attentionSettlementData" ||
              // cat === "completeSettlementData" ||  //8
              cat === "featureSettlementData" ||
              cat === "enrollSettlementForUserData" ||
              cat === "allSettlementData"
                ? "view-all"
                : "view-all hide"
            }
          >
            {catText}
            <br />
            <a className='hide view-all-a' onClick={this.onViewAll}>
              View All
            </a>
          </div>
        </li>
        <SettlementModal
          open={this.state.openInfoDialog}
          onClose={this.handleClose}
          item={item}
          name={name}
          price={price}
          tbdAmount={tbdAmount}
          settlementDocumentDtoList1={settlementDocumentDtoList1}
        />
      </span>
    );
  }
}

PlanStub.contextTypes = {
  router: PropTypes.object.isRequired,
};
// const mapStateToProps = (state) => ({ data: state.data });
function mapStateToProps(state) {
  console.log('state.data', state.data.setFilteredDSettlement)
  return {
    data: state.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveUsersUneligibleSettlements,
      tutorialPopupStateAction2,
      tutorialPopupStateAction3,
      tutorialPopupStateAction,
      tutorialPopupStateAction4,
      tutorialPopupStateAction5,
      clearTutorialPopupStateAction,
      clearTutorialPopupStateAction2,
      clearTutorialPopupStateAction3,
      clearTutorialPopupStateAction4,
      getConsumerUser,
      clearTutorialPopupStateAction5,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PlanStub);
